import { useQuery } from '@tanstack/react-query';

import { getReport } from '../api/reports.api';
import { REPORT_DETAIL_QUERY_KEY } from '../constants/reports-query-keys';

export const useReport = (reportId: string) => {
  return useQuery({
    queryKey: REPORT_DETAIL_QUERY_KEY(reportId),
    queryFn: () => getReport(reportId),
    staleTime: 5 * 60 * 1000,
    enabled: !!reportId,
  });
};
